export class GoogleMapConfig {
  static readonly restrictedBounds = {
    north: 75,
    south: 0,
    east: -60,
    west: -179.9,
  };
}
